import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';

import { getMeetingsAPIBaseUrl } from './getEnvConfig';
import { chunk } from './utils';
import { MeetingItem } from '../types';

type props = {
  ids: string[];
  projectId: string;
};

export const getEntitiesByIds = ({ ids: entityIds, projectId }: props) => {
  const idChunks = chunk(entityIds, 10);
  return Promise.all(
    idChunks.map((idsBatch) =>
      fetchWithToken(
        getMeetingsAPIBaseUrl({
          path: `/items:last-in-series?filter[id]=${idsBatch.join(',')}`,
          projectId,
        }),
      ),
    ),
  )
    .then((response) => response.map((response) => response).flat())
    .then((response) =>
      response.map(
        (response) => (response as { results: [MeetingItem] }).results,
      ),
    )
    .then((results) => results.flat())
    .then((flattenedResults) => ({
      data: flattenedResults as [MeetingItem],
    }));
};
